import $ from "jquery";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export default class ThemeService {
    private themeSource = new BehaviorSubject<string>("");
    theme$ = this.themeSource.asObservable();

    private eventSource = new BehaviorSubject<string>("");
    eventTheme$ = this.eventSource.asObservable();

    constructor() {
        // No stored preference yet (fresh session, or the real ColorScheme preference hasn't
        // loaded from the backend yet) — fall back to the OS-level preference rather than
        // hard-defaulting to light.
        const stored = localStorage.getItem("arcusTheme");
        const theme = stored ?? (window.matchMedia("(prefers-color-scheme: dark)").matches ? "arcusDark" : "arcus");
        this.themeSource.next(theme);
        theme == "arcusDark" ? $("body").addClass("arcus-dark-theme") : null;
    }

    currentTheme(): string {
        // Leaving this here for legacy purposes TODO: remove me once all calls are observer-based
        return this.themeSource.getValue();
    }

    toggleTheme = (): void => {
        this.themeSource.next(this.themeSource.getValue() === "arcus" ? "arcusDark" : "arcus");
        $("body").toggleClass("arcus-dark-theme");
        localStorage.setItem("arcusTheme", this.themeSource.getValue());
    };

    toggleEventTheme(eventTheme) {
        this.eventSource.next($("body").hasClass(eventTheme) ? "" : eventTheme);
        $("body").toggleClass(eventTheme);
    }

    christmas() {
        this.toggleEventTheme("arcus-christmas");
    }
}
